import { render } from "./ColorPicker.vue?vue&type=template&id=3de8bb4f&scoped=true"
import script from "./ColorPicker.vue?vue&type=script&lang=ts"
export * from "./ColorPicker.vue?vue&type=script&lang=ts"

import "./ColorPicker.vue?vue&type=style&index=0&id=3de8bb4f&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3de8bb4f"

export default script